import EmptyFiles from '../EmptyFiles/EmptyFiles';

const NoSearchResults = () => {
  return (
    <div className='flex flex-col items-center justify-center'>
      <EmptyFiles title='No Results' subhead='No files or folders matched this search.' />
    </div>
  );
};

export default NoSearchResults;
